import React from 'react';

import { match, Route, Switch } from 'react-router-dom';

import { useSelector } from 'react-redux';
import * as store from '../../../reducers/store';

import LandingPage from './LandingPage';
import Details from './Details';
import Search from './Search';

import { ORGANIZATION_ID_TO_ORIGIN } from './Common';

interface Props {
  match: match;
}

const ProviderDirectory: React.FC<Props> = ({ match }) => {
  const organizationId = useSelector(
    (store: store.All) => store.inbound.organizationId,
  );
  const embedded = useSelector((store: store.All) => store.embedded);

  const app = document.getElementById('embedded-app');
  const sendHeight = () => {
    const height = app?.clientHeight;
    if (height) {
      ORGANIZATION_ID_TO_ORIGIN[organizationId].forEach((origin) => {
        window.parent.postMessage({ height }, origin);
      });
    }
  };
  if (embedded) {
    window.onresize = sendHeight;
  }
  return (
    <Switch>
      <Route
        path={`${match.path}/search`}
        render={(props) => <Search sendHeight={sendHeight} {...props} />}
      />
      <Route
        path={`${match.path}/:providerSlug`}
        render={(props) => (
          <Details
            landingPageUrl={match.url}
            sendHeight={sendHeight}
            {...props}
          />
        )}
      />
      <Route
        path={`${match.path}`}
        render={(props) => <LandingPage sendHeight={sendHeight} {...props} />}
      />
    </Switch>
  );
};

export default ProviderDirectory;
